module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)14.f3bdce3d.jpg";